import React, { useEffect, useState } from "react";
import { useAuth } from "../../providers/AuthenticationProvider";
import Container from "@mui/material/Container";
import { Box, Stack } from "@mui/material";
import logo from "../../assets/logo.png";
import { useNavigate } from "react-router-dom";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Button from "@mui/material/Button";
import { useSnackbar } from "../../providers/SnackbarProvider";
export const Login = () => {
	const [email, setEmail] = useState<string>("");
	const [password, setPassword] = useState<string>("");
	const [showPassword, setShowPassword] = useState(false);
	const { openSnackbar } = useSnackbar();
	const { loginWithEmailAndPassword } = useAuth();

	const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setEmail(event.target.value);
	};

	const handlePasswordChange = (
		event: React.ChangeEvent<HTMLInputElement>
	) => {
		setPassword(event.target.value);
	};
	const handleClickShowPassword = () => {
		setShowPassword(!showPassword);
	};

	const handleLogin = async () => {
		try {
			await loginWithEmailAndPassword(email, password);
			openSnackbar("", "Login avvenuto con successo", "success");
		} catch (err) {
			const error = err as Error;
			console.log(err);
			openSnackbar("", error.message, "error");
		}
	};
	const navigate = useNavigate();

	return (
		<Container>
			<Box mt={16} sx={{ marginBottom: 12, fontWeight: "bold" }}>
				<img
					src={logo}
					style={{
						width: "220px",
						display: "block",
						margin: "auto",
					}}
				/>

				<div
					style={{
						textTransform: "uppercase",
						textAlign: "center",
						margin: "10px auto",
						fontSize: "16px",
						fontFamily: "Work Sans !important",
					}}
				>
					Login
				</div>
			</Box>

			<Stack
				spacing={2}
				sx={{ maxWidth: 440, margin: "auto", display: "block" }}
			>
				<TextField
					id="email"
					label="Email"
					color="primary"
					fullWidth
					value={email}
					onChange={handleEmailChange}
					onKeyDown={(event) => {
						if (event.key === "Enter") {
							handleLogin();
							event.preventDefault();
						}
					}}
				/>
				<TextField
					id="password"
					label="Password"
					fullWidth
					type={showPassword ? "text" : "password"}
					autoComplete="current-password"
					value={password}
					onChange={handlePasswordChange}
					InputProps={{
						endAdornment: (
							<InputAdornment position="end">
								<IconButton
									aria-label="toggle password visibility"
									onClick={handleClickShowPassword}
									edge="end"
								>
									{showPassword ? (
										<VisibilityOff />
									) : (
										<Visibility />
									)}
								</IconButton>
							</InputAdornment>
						),
					}}
					onKeyDown={(event) => {
						if (event.key === "Enter") {
							handleLogin();
							event.preventDefault();
						}
					}}
				/>
				<Button
					variant="contained"
					color="secondary"
					onClick={handleLogin}
					size="large"
					fullWidth
					sx={{
						height: "55px",
						textTransform: "none",
						fontFamily: "Work Sans !important",
					}}
					onKeyDown={(event) => {
						if (event.key === "Enter") {
							handleLogin();
							event.preventDefault();
						}
					}}
				>
					Login
				</Button>
			</Stack>

			<Stack
				alignItems={"center"}
				sx={{
					marginTop: 2,
				}}
			>
				<Button
					variant="text"
					color="secondary"
					sx={{
						textTransform: "none",
						fontFamily: "Work Sans !important",
					}}
					onClick={() => {
						navigate("/signup");
					}}
				>
					Don't have account? Sing Up
				</Button>
			</Stack>
		</Container>
	);
};
